
<div class="homeCard homeHighlight" routerLink="/events/poster-competition-2019">
  <h2 class="title">
    <span style="color: red">**更改** </span> 樂齡香港健康老齡化社區校際海報創作設計比賽 2019
  </h2>
</div>

<div>
  <div class="homeCard">
    <h2 class="title">
      <span style="color: red">Cancelled: </span> 樂齡香港嘉年華 2019
    </h2>
  </div>
</div>


